/**
 * L20 — Admin chrome (bottom nav / compact shell chrome) hidden on auth routes.
 * Exactly: `/`, `/tenants`, `/register`, `/dev/login`, `/dev/forgot-password`,
 * `/dev/reset-password`, `/:tenant/login`, `/:tenant/invite`,
 * `/:tenant/forgot-password`, `/:tenant/reset-password` (plus legacy
 * `/:tenant/admin/…` auth paths).
 */
export function shouldHideAdminChrome(pathname: string): boolean {
  if (
    pathname === '/dev/login' ||
    pathname.startsWith('/dev/login/') ||
    pathname === '/dev/forgot-password' ||
    pathname.startsWith('/dev/forgot-password/') ||
    pathname === '/dev/reset-password' ||
    pathname.startsWith('/dev/reset-password/')
  ) {
    return true;
  }
  if (pathname === '/' || pathname === '') {
    return true;
  }
  if (
    pathname === '/tenants' ||
    pathname.startsWith('/tenants/') ||
    pathname === '/register' ||
    pathname.startsWith('/register/')
  ) {
    return true;
  }
  if (/^\/[^/]+\/(?:admin\/)?login\/?$/.test(pathname)) {
    return true;
  }
  if (/^\/[^/]+\/(?:admin\/)?invite\/?$/.test(pathname)) {
    return true;
  }
  if (/^\/[^/]+\/(?:admin\/)?forgot-password\/?$/.test(pathname)) {
    return true;
  }
  if (/^\/[^/]+\/(?:admin\/)?reset-password\/?$/.test(pathname)) {
    return true;
  }
  return false;
}
